module.exports = __webpack_public_path__ + "static/media/handbags.3e5c677c.png";